import { store } from "@redux";
import axios from "axios";

const axiosGo = axios.create({
    baseURL: process.env.REACT_APP_API_URL_GO,

    //   paramsSerializer: (params) => queryString.stringify(params),
});

axiosGo.interceptors.request.use((config) => {
    const merchantId = store.getState().auth.merchantId || store.getState().merchant._id;
    const userId = store.getState().auth.userInfo?._id || "";
    config.headers["rocket-merchant-id"] = merchantId;
    config.headers["rocket-user-id"] = userId;

    return config;
});

export default axiosGo;
